import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { TranslateModule } from '@ngx-translate/core';

import { PlatfromConfirmDialogComponent } from './platform-confirm-dialog/platfrom-confirm-dialog.component';
@NgModule({
    declarations: [
        PlatfromConfirmDialogComponent
    ],
    imports: [
        MatDialogModule,
        MatButtonModule,
        FlexLayoutModule.withConfig({
            useColumnBasisZero: false,
               printWithBreakpoints: ['xs', 'sm', 'md', 'lg', 'xl', 'lt-sm', 'lt-md', 'lt-lg', 'lt-xl', 'gt-xs', 'gt-sm', 'gt- md', 'gt-lg']
       }),
        TranslateModule.forChild()
    ]
})
export class PlatformConfirmDialogModule {
}
